import { makeStyles } from '@material-ui/core/styles';
import { secondaryButtonStyle } from '../../../shared/styles/buttons.styles';
import { redesignTheme } from '../../../theme';

const { spacing, breakpoints, radius, colors } = redesignTheme;

export const useFloatingEbookActionsStyles = makeStyles(() => ({
  floatingActions: {
    position: 'fixed',
    right: spacing.lg,
    bottom: spacing.lg,
    zIndex: 20,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    gap: 12,
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      right: spacing.sm,
      bottom: spacing.sm,
    },
  },
  summaryButton: {
    ...secondaryButtonStyle,
    textDecoration: 'none',
    boxShadow: '0 8px 20px rgba(14, 18, 71, 0.08)',
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      width: 48,
      padding: 0,
      borderRadius: radius.md,
      '& span': {
        display: 'none',
      },
    },
  },
  summaryIcon: {
    width: 16,
    height: 16,
    color: colors.primaryDark,
  },
  backToTopButton: {
    width: 48,
    height: 48,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: radius.md,
    backgroundColor: colors.primary,
    color: colors.white,
    textDecoration: 'none',
    boxShadow: '0 8px 20px rgba(0, 10, 141, 0.22)',
    '& svg': {
      width: 24,
      height: 24,
      color: colors.white,
    },
  },
}));
